/** Expected `format` from server export (optional for hand-made files). */
export const ABOUT_US_BUNDLE_FORMAT = "alramlaa-about-us";

/**
 * Client-side validation before POST import.
 * @param {unknown} data
 * @returns {{ ok: true } | { ok: false, message: string }}
 */
export function validateAboutUsBackup(data) {
  if (data == null || typeof data !== "object" || Array.isArray(data)) {
    return { ok: false, message: "Backup must be a JSON object." };
  }
  if (
    data.format != null &&
    data.format !== ABOUT_US_BUNDLE_FORMAT &&
    typeof data.format === "string"
  ) {
    return {
      ok: false,
      message: `Unknown backup format: ${data.format}. Expected "${ABOUT_US_BUNDLE_FORMAT}" or omit format.`,
    };
  }
  if (data.version != null) {
    const v = Number(data.version);
    if (!Number.isFinite(v) || v !== 1) {
      return {
        ok: false,
        message: `Unsupported backup version: ${String(data.version)}.`,
      };
    }
  }
  if ("about" in data && data.about != null && typeof data.about !== "object") {
    return { ok: false, message: "Field about must be an object or null." };
  }
  if ("values" in data && !Array.isArray(data.values)) {
    return { ok: false, message: "Field values must be an array when present." };
  }
  if ("questions" in data && !Array.isArray(data.questions)) {
    return { ok: false, message: "Field questions must be an array when present." };
  }
  return { ok: true };
}
